import { getStoredRole } from "auth/session";
import { useCallback, useMemo } from "react";
import { Departments, UserRoles } from "../lib/constants";
import useApiService from "./useApiService";

const staticEmployees = [
  {
    id: 1,
    name: "John Doe",
    email: "W6LsM@example.com",
    contact: "1234567890",
    position: "Position",
    department: Departments.DESIGN,
    employment_period: "1 year 2 months",
    status: "Active",
    age: 29,
    gender: "Male",
    weekly_hours_available: 40,
    current_salary: "60000",
    payslips: [
      {
        file_name: "1_Dec_2024_Payslip.pdf",
        file_url: "https://example.com/payslips/1_Dec_2024_Payslip.pdf",
        month: "December",
        year: "2024",
      },
      {
        file_name: "1_Jan_2025_Payslip.pdf",
        file_url: "https://example.com/payslips/1_Jan_2025_Payslip.pdf",
        month: "January",
        year: "2025",
      },
      {
        file_name: "1_Feb_2025_Payslip.pdf",
        file_url: "https://example.com/payslips/1_Feb_2025_Payslip.pdf",
        month: "February",
        year: "2025",
      },
    ],
    salary: {
      deductions: [
        { title: "Basic", amount: "43750", ytd: "87500" },
        { title: "House Rent Allowance", amount: "21875", ytd: "43750" },
        { title: "Conveyance Allowance", amount: "6000", ytd: "12000" },
        { title: "Training Allowance", amount: "4000", ytd: "8000" },
        { title: "Fixed Allowance", amount: "6625", ytd: "13250" },
      ],
      earnings: [
        { title: "EPF contribution", amount: "5250", ytd: "10500" },
        { title: "Professional Tax", amount: "1250", ytd: "1250" },
      ],
      gross_earnings: "82250",
      total_deductions: "6500",
    },
  },
  {
    id: 2,
    name: "John Doe",
    email: "W6LsM@example.com",
    contact: "1234567890",
    position: "Position",
    department: Departments.DRAWING,
    employment_period: "2 year 3 months",
    status: "Active",
    age: 34,
    gender: "Male",
    weekly_hours_available: 38,
    current_salary: "65000",
    payslips: [
      {
        file_name: "2_Dec_2024_Payslip.pdf",
        file_url: "https://example.com/payslips/2_Dec_2024_Payslip.pdf",
        month: "December",
        year: "2024",
      },
      {
        file_name: "2_Jan_2025_Payslip.pdf",
        file_url: "https://example.com/payslips/2_Jan_2025_Payslip.pdf",
        month: "January",
        year: "2025",
      },
      {
        file_name: "2_Feb_2025_Payslip.pdf",
        file_url: "https://example.com/payslips/2_Feb_2025_Payslip.pdf",
        month: "February",
        year: "2025",
      },
    ],
    salary: {
      deductions: [
        { title: "Basic", amount: "43750", ytd: "87500" },
        { title: "House Rent Allowance", amount: "21875", ytd: "43750" },
        { title: "Conveyance Allowance", amount: "6000", ytd: "12000" },
        { title: "Training Allowance", amount: "4000", ytd: "8000" },
        { title: "Fixed Allowance", amount: "6625", ytd: "13250" },
      ],
      earnings: [
        { title: "EPF contribution", amount: "5250", ytd: "10500" },
        { title: "Professional Tax", amount: "1250", ytd: "1250" },
      ],
      gross_earnings: "82250",
      total_deductions: "6500",
    },
  },
  {
    id: 3,
    name: "John Doe",
    email: "W6LsM@example.com",
    contact: "1234567890",
    position: "Position",
    department: Departments.SITE_VISIT,
    employment_period: "3 year 4 months",
    status: "Inactive",
    age: 41,
    gender: "Male",
    site_visits_scheduled: 3,
    current_salary: 70000,
    payslips: [
      {
        file_name: "3_Dec_2024_Payslip.pdf",
        file_url: "https://example.com/payslips/3_Dec_2024_Payslip.pdf",
        month: "December",
        year: "2024",
      },
      {
        file_name: "3_Jan_2025_Payslip.pdf",
        file_url: "https://example.com/payslips/3_Jan_2025_Payslip.pdf",
        month: "January",
        year: "2025",
      },
      {
        file_name: "3_Feb_2025_Payslip.pdf",
        file_url: "https://example.com/payslips/3_Feb_2025_Payslip.pdf",
        month: "February",
        year: "2025",
      },
    ],
    salary: {
      deductions: [
        { title: "Basic", amount: "43750", ytd: "87500" },
        { title: "House Rent Allowance", amount: "21875", ytd: "43750" },
        { title: "Conveyance Allowance", amount: "6000", ytd: "12000" },
        { title: "Training Allowance", amount: "4000", ytd: "8000" },
        { title: "Fixed Allowance", amount: "6625", ytd: "13250" },
      ],
      earnings: [
        { title: "EPF contribution", amount: "5250", ytd: "10500" },
        { title: "Professional Tax", amount: "1250", ytd: "1250" },
      ],
      gross_earnings: "82250",
      total_deductions: "6500",
    },
  },
  {
    id: 4,
    name: "John Doe",
    email: "W6LsM@example.com",
    contact: "1234567890",
    position: "Position",
    department: Departments.DESIGN,
    employment_period: "4 year 5 months",
    status: "Inactive",
    age: 37,
    gender: "Male",
    weekly_hours_available: 32,
    current_salary: 72000,
    payslips: [
      {
        file_name: "4_Dec_2024_Payslip.pdf",
        file_url: "https://example.com/payslips/4_Dec_2024_Payslip.pdf",
        month: "December",
        year: "2024",
      },
      {
        file_name: "4_Jan_2025_Payslip.pdf",
        file_url: "https://example.com/payslips/4_Jan_2025_Payslip.pdf",
        month: "January",
        year: "2025",
      },
      {
        file_name: "4_Feb_2025_Payslip.pdf",
        file_url: "https://example.com/payslips/4_Feb_2025_Payslip.pdf",
        month: "February",
        year: "2025",
      },
    ],
    salary: {
      deductions: [
        { title: "Basic", amount: "43750", ytd: "87500" },
        { title: "House Rent Allowance", amount: "21875", ytd: "43750" },
        { title: "Conveyance Allowance", amount: "6000", ytd: "12000" },
        { title: "Training Allowance", amount: "4000", ytd: "8000" },
        { title: "Fixed Allowance", amount: "6625", ytd: "13250" },
      ],
      earnings: [
        { title: "EPF contribution", amount: "5250", ytd: "10500" },
        { title: "Professional Tax", amount: "1250", ytd: "1250" },
      ],
      gross_earnings: "82250",
      total_deductions: "6500",
    },
  },
  {
    id: 5,
    name: "John Doe",
    email: "W6LsM@example.com",
    contact: "1234567890",
    position: "Position",
    department: Departments.DRAWING,
    employment_period: "5 year 6 months",
    status: "Inactive",
    age: 45,
    gender: "Male",
    weekly_hours_available: 28,
    current_salary: 75000,
    payslips: [
      {
        file_name: "5_Dec_2024_Payslip.pdf",
        file_url: "https://example.com/payslips/5_Dec_2024_Payslip.pdf",
        month: "December",
        year: "2024",
      },
      {
        file_name: "5_Jan_2025_Payslip.pdf",
        file_url: "https://example.com/payslips/5_Jan_2025_Payslip.pdf",
        month: "January",
        year: "2025",
      },
      {
        file_name: "5_Feb_2025_Payslip.pdf",
        file_url: "https://example.com/payslips/5_Feb_2025_Payslip.pdf",
        month: "February",
        year: "2025",
      },
    ],
    salary: {
      deductions: [
        { title: "Basic", amount: "43750", ytd: "87500" },
        { title: "House Rent Allowance", amount: "21875", ytd: "43750" },
        { title: "Conveyance Allowance", amount: "6000", ytd: "12000" },
        { title: "Training Allowance", amount: "4000", ytd: "8000" },
        { title: "Fixed Allowance", amount: "6625", ytd: "13250" },
      ],
      earnings: [
        { title: "EPF contribution", amount: "5250", ytd: "10500" },
        { title: "Professional Tax", amount: "1250", ytd: "1250" },
      ],
      gross_earnings: "82250",
      total_deductions: "6500",
    },
  },
  {
    id: 6,
    name: "John Doe",
    email: "W6LsM@example.com",
    contact: "1234567890",
    position: "Position",
    department: Departments.SITE_VISIT,
    employment_period: "6 year 7 months",
    status: "Active",
    age: 31,
    gender: "Male",
    site_visits_scheduled: 5,
    current_salary: 80000,
    payslips: [
      {
        file_name: "6_Dec_2024_Payslip.pdf",
        file_url: "https://example.com/payslips/6_Dec_2024_Payslip.pdf",
        month: "December",
        year: "2024",
      },
      {
        file_name: "6_Jan_2025_Payslip.pdf",
        file_url: "https://example.com/payslips/6_Jan_2025_Payslip.pdf",
        month: "January",
        year: "2025",
      },
      {
        file_name: "6_Feb_2025_Payslip.pdf",
        file_url: "https://example.com/payslips/6_Feb_2025_Payslip.pdf",
        month: "February",
        year: "2025",
      },
    ],
    salary: {
      deductions: [
        { title: "Basic", amount: "43750", ytd: "87500" },
        { title: "House Rent Allowance", amount: "21875", ytd: "43750" },
        { title: "Conveyance Allowance", amount: "6000", ytd: "12000" },
        { title: "Training Allowance", amount: "4000", ytd: "8000" },
        { title: "Fixed Allowance", amount: "6625", ytd: "13250" },
      ],
      earnings: [
        { title: "EPF contribution", amount: "5250", ytd: "10500" },
        { title: "Professional Tax", amount: "1250", ytd: "1250" },
      ],
      gross_earnings: "82250",
      total_deductions: "6500",
    },
  },
  {
    id: 7,
    name: "John Doe",
    email: "W6LsM@example.com",
    contact: "1234567890",
    position: "Position",
    department: Departments.DESIGN,
    employment_period: "7 year 8 months",
    status: "Active",
    age: 38,
    gender: "Male",
    weekly_hours_available: 30,
    current_salary: 85000,
    payslips: [
      {
        file_name: "7_Dec_2024_Payslip.pdf",
        file_url: "https://example.com/payslips/7_Dec_2024_Payslip.pdf",
        month: "Dec",
        year: 2024,
      },
      {
        file_name: "7_Jan_2025_Payslip.pdf",
        file_url: "https://example.com/payslips/7_Jan_2025_Payslip.pdf",
        month: "January",
        year: "2025",
      },
      {
        file_name: "7_Feb_2025_Payslip.pdf",
        file_url: "https://example.com/payslips/7_Feb_2025_Payslip.pdf",
        month: "February",
        year: "2025",
      },
    ],
    salary: {
      deductions: [
        { title: "Basic", amount: "43750", ytd: "87500" },
        { title: "House Rent Allowance", amount: "21875", ytd: "43750" },
        { title: "Conveyance Allowance", amount: "6000", ytd: "12000" },
        { title: "Training Allowance", amount: "4000", ytd: "8000" },
        { title: "Fixed Allowance", amount: "6625", ytd: "13250" },
      ],
      earnings: [
        { title: "EPF contribution", amount: "5250", ytd: "10500" },
        { title: "Professional Tax", amount: "1250", ytd: "1250" },
      ],
      gross_earnings: "82250",
      total_deductions: "6500",
    },
  },
  {
    id: 8,
    name: "John Doe",
    email: "W6LsM@example.com",
    contact: "1234567890",
    position: "Position",
    department: Departments.DRAWING,
    employment_period: "8 year 9 months",
    status: "Active",
    age: 42,
    gender: "Male",
    weekly_hours_available: 34,
    current_salary: 90000,
    payslips: [
      {
        file_name: "8_Dec_2024_Payslip.pdf",
        file_url: "https://example.com/payslips/8_Dec_2024_Payslip.pdf",
        month: "December",
        year: "2024",
      },
      {
        file_name: "8_Jan_2025_Payslip.pdf",
        file_url: "https://example.com/payslips/8_Jan_2025_Payslip.pdf",
        month: "January",
        year: "2025",
      },
      {
        file_name: "8_Feb_2025_Payslip.pdf",
        file_url: "https://example.com/payslips/8_Feb_2025_Payslip.pdf",
        month: "February",
        year: "2025",
      },
    ],
    salary: {
      deductions: [
        { title: "Basic", amount: "43750", ytd: "87500" },
        { title: "House Rent Allowance", amount: "21875", ytd: "43750" },
        { title: "Conveyance Allowance", amount: "6000", ytd: "12000" },
        { title: "Training Allowance", amount: "4000", ytd: "8000" },
        { title: "Fixed Allowance", amount: "6625", ytd: "13250" },
      ],
      earnings: [
        { title: "EPF contribution", amount: "5250", ytd: "10500" },
        { title: "Professional Tax", amount: "1250", ytd: "1250" },
      ],
      gross_earnings: "82250",
      total_deductions: "6500",
    },
  },
];

const actualHours = 42.5;
const staticEmployeesAttendance = Array.from({ length: 10 }).map((_, idx) => {
  const departments = Object.values(Departments);

  return {
    employee_id: idx + 1,
    employee_name: `Employee ${idx + 1}`,
    department: departments[Math.floor(Math.random() * departments.length)],
    month: "February",
    year: "2025",
    attendance: Array.from({ length: 4 }).map((_, idx) => {
      const status = ["pending", "closed"][Math.floor(Math.random() * 2)];
      const working_hours = actualHours + Math.floor(Math.random() * 10) - 5;
      const negative_hours = working_hours < actualHours ? actualHours - working_hours : null;
      const additional_hours = working_hours > actualHours ? working_hours - actualHours : null;
      // overtime is assigned if addtional hours is greater than 0 and status is closed, calculated as less than additional hours
      // negative_hours assigned if status is closed, calculated as less than negative hours or additional hours
      // null_hours calculated if status is closed and is lesss than additional h?ours or negative hours
      // if addtional_time is not null .. overtime_assigned + negative_hours + null_hours = additional_hours
      // if negative_hours is not null
      // negative_hours + null_hours =  negative_hours
      let overtime_assigned = null;
      let null_hours_assigned = null;
      let negative_hours_assigned = null;
      if (status === "closed") {
        if (additional_hours) {
          overtime_assigned = Math.floor(Math.random() * additional_hours);
          null_hours_assigned = additional_hours - overtime_assigned;
          negative_hours_assigned = Math.floor(Math.random() * (additional_hours - overtime_assigned));
          null_hours_assigned = additional_hours - overtime_assigned - negative_hours_assigned;
        } else if (negative_hours) {
          negative_hours_assigned = Math.floor(Math.random() * negative_hours);
          null_hours_assigned = negative_hours - negative_hours_assigned;
        }
      }

      return {
        week: idx + 1,
        hours: actualHours,
        working_hours,
        negative_hours,
        additional_hours,
        status,
        overtime_assigned,
        null_hours_assigned,
        negative_hours_assigned,
        reason: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit, est!",
      };
    }),
  };
});

const useEmployee = () => {
  const employeeId = useMemo(() => JSON.parse(localStorage.getItem("userData")).employee_id, []);
  const { get, post } = useApiService();

  const checkRole = useCallback(() => {
    return getStoredRole();
  }, []);

  const getAllEmployees = useCallback(async () => {
    const userRole = checkRole();
    let apiUrl = "";
    if (userRole === UserRoles.ANALYST || userRole === UserRoles.ADMIN) {
      apiUrl = "/api/analyst/employees";
    } else {
      return {
        error: "Unauthorized",
      };
    }

    // return { employees: staticEmployees, success: true };

    try {
      const response = await get(apiUrl);
      if (response.status) return { employees: response.data, success: response.status };
      else throw new Error(response.message);
    } catch (error) {
      return { error };
    }
  }, [checkRole, get]);

  const getEmployeeList = useCallback(async () => {
    return { employees: staticEmployees, success: true };
  }, []);

  const getEmployeeDetails = useCallback((id) => {
    console.log(id);
    const employee = staticEmployees.find((emp) => emp.id === id);
    if (!employee) return { error: "Employee not found" };
    return {
      employee: {
        id: employee.id,
        name: employee.name,
        age: employee.age,
        gender: employee.gender,
        contact: employee.contact,
        email: employee.email,
        employment_period: employee.employment_period,
        current_salary: employee.current_salary,
        status: employee.status,
        salary: employee.salary,
        payslips: employee.payslips,
      },
    };
  }, []);

  const getAllEmployeesForWorkAllotment = useCallback(async () => {
    const role = checkRole();
    if (role !== UserRoles.ANALYST) return { error: "Unauthorized" };
    try {
      const apiUrl = "/api/analyst/employees/assignment";
      const response = await get(apiUrl);
      if (response.status) return { employees: response.data, success: response.status };
      else throw new Error(response.message);
    } catch (error) {
      return { error };
    }
  }, [checkRole, get]);

  const getEmployeeScheduleById = useCallback(
    async (id) => {
      if (!id) return { error: "Employee Id is required" };
      try {
        const response = await get(`/analyst/employee/${id}/schedule`);
        console.log(response);
        if (response.status) return { schedule: response.data, success: response.status };
        else throw new Error(response.message);
      } catch (error) {
        if (error.message === "Not Found") return { schedule: [] };
        return { error };
      }
    },
    [get]
  );

  const getEmployeeAttendanceByMonth = useCallback((month, year) => {
    const attendanceArr = staticEmployeesAttendance.map((employee) => {
      // get all employee data except attendance in object employeeData
      const { attendance, ...employeeData } = employee;
      const attArray = employee.attendance.map((item) => ({ ...item, ...employeeData }));
      // console.log(attArray);
      return [...attArray];
    });
    return { attendance: attendanceArr.flatMap((item) => item) };
  }, []);

  const requestPasswordReset = useCallback(
    async (id) => {
      if (!id) throw new Error("Employee Id is required");
      const role = checkRole();
      if (role !== UserRoles.ADMIN) return { error: "Unauthorized" };

      const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      let newPassString = "";
      for (let i = 0; i < 10; i++) {
        newPassString += characters.charAt(Math.floor(Math.random() * characters.length));
      }
      return { data: { user_id: id, new_password: newPassString } };

      // try {
      //   const response = get(`/api/hr/get-password/${id}`);
      //   if (response.status) return { data: response.data };
      // } catch (error) {
      //   return { error: error.message || "Failed to reset user password" };
      // }
    },
    [checkRole]
  );

  const requestLeave = async (data) => {
    if (!data) throw new Error("Leave data is required.");
    try {
      const apiUrl = "/api/leave-request";
      const response = await post(apiUrl, data);
      if (response.status) return { success: response.message };
      else return { error: response.message };
    } catch (error) {
      return { error: error.message ?? "Failed to request leave" };
    }
  };

  const getAppliedLeaves = useCallback(async () => {
    try {
      const apiUrl = `/api/leave-requests/${employeeId}`;
      const response = await get(apiUrl);
      if (response.status) return { success: response.message, leaves: response.data };
      else return { error: response.message ?? "Failed to fetch leaves data", leaves: [] };
    } catch (error) {
      return { error: error.message ?? "Failed to fetch leaves data", leaves: [] };
    }
  }, [get, employeeId]);

  const submitFeedback = async (data) => {
    if (!data) throw new Error("Feedback data is required.");
    const dataToSubmit = { ...data, employee_id: employeeId };
    try {
      const apiUrl = "/api/feedback";
      const response = await post(apiUrl, dataToSubmit);
      if (response.status) return { success: response.message };
      else return { error: response.message };
    } catch (error) {
      return { error: error.message ?? "Failed to submit feedback" };
    }
  };

  const requestVoucher = async (data) => {
    if (!data) throw new Error("Voucher data is required.");
    const dataToSubmit = {
      ...data,
      comment: data.note,
      attachment: data.document,
      status: "Active",
      employee_id: employeeId,
    };
    try {
      const apiUrl = "/api/reimbursement-request";
      const response = await post(apiUrl, dataToSubmit);
      if (response.status) return { success: response.message };
      else return { error: response.message };
    } catch (error) {
      return { error: error.message ?? "Failed to request voucher" };
    }
  };

  const getRequestedVouchers = useCallback(async () => {
    try {
      const apiUrl = `/api/reimbursement-requests/${employeeId}`;
      const response = await get(apiUrl);
      if (response.status) return { success: response.message, vouchers: response.data };
      else return { error: response.message ?? "Failed to fetch vouchers data", vouchers: [] };
    } catch (error) {
      return { error: error.message ?? "Failed to fetch vouchers data", vouchers: [] };
    }
  }, [get, employeeId]);

  return {
    getAllEmployees,
    getEmployeeDetails,
    getEmployeeAttendanceByMonth,
    getEmployeeList,

    getAllEmployeesForWorkAllotment,
    requestPasswordReset,
    getEmployeeScheduleById,

    requestLeave,
    getAppliedLeaves,
    submitFeedback,
    requestVoucher,
    getRequestedVouchers,
  };
};

export default useEmployee;
